import { render, staticRenderFns } from "./ClujiCard.vue?vue&type=template&id=818b66ba&scoped=true"
import script from "./ClujiCard.vue?vue&type=script&lang=js"
export * from "./ClujiCard.vue?vue&type=script&lang=js"
import style0 from "./ClujiCard.vue?vue&type=style&index=0&id=818b66ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818b66ba",
  null
  
)

export default component.exports